import type { GenericEntity } from './types';
import { DEFAULT_SCOPE_NAME } from './types';

export const resolveScope = (scope?: string | null) =>
  typeof scope === 'string' ? scope : DEFAULT_SCOPE_NAME;

export const resolveReferenceKey = (refIdKey: string) => refIdKey.replace('Id', '');

export const mapReferences = <T extends GenericEntity>(
  references: Partial<{ [k in keyof T]: T[k] }>,
  entity: T,
) => {
  Object.entries(references).map(([referenceIdKey, referenceEntityState]) => {
    const refId = entity[<keyof T>referenceIdKey];
    const referenceEntityValue = refId ? referenceEntityState.entityMap[refId] : null;
    const referenceEntityNewKey = resolveReferenceKey(referenceIdKey);
    entity[<keyof T>referenceEntityNewKey] = referenceEntityValue;
  });

  return entity;
};
